<template>
  <div class="container">
    <div class="warp" @click="clickClose">
      <img
        class="arrow"
        src="https://assets.rurushishi.com/yq-rs-make/components/share/arrow.png?x-oss-process=image/resize,h_100,w_100"
        alt
      >
      <div class="tips">点击右上方转发给好友或群</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    clickClose: function() {
      this.$emit("close");
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="css" scoped>
.warp {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 35;
}
.arrow {
  position: fixed;
  top: 0%;
  right: 22%;
  height: 13%;
}
.tips {
  position: fixed;
  top: 13%;
  right: 20%;
  border: 1px solid #ffffff;
  color: #ffffff;
  padding: 0.3rem;
}
</style>